import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChartHorizontalBars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 3.5C4.25 3.08579 3.91421 2.75 3.5 2.75C3.08579 2.75 2.75 3.08579 2.75 3.5V21.5C2.75 21.9142 3.08579 22.25 3.5 22.25C3.91421 22.25 4.25 21.9142 4.25 21.5V3.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.5 4.25C13.4665 4.25 14.25 5.0335 14.25 6V10C14.25 10.9665 13.4665 11.75 12.5 11.75H7.25C6.2835 11.75 5.5 10.9665 5.5 10V6C5.5 5.0335 6.2835 4.25 7.25 4.25H12.5ZM12.75 6C12.75 5.86193 12.6381 5.75 12.5 5.75H7.25C7.11193 5.75 7 5.86193 7 6V10C7 10.1381 7.11193 10.25 7.25 10.25H12.5C12.6381 10.25 12.75 10.1381 12.75 10V6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 13.25C20.4665 13.25 21.25 14.0335 21.25 15V19C21.25 19.9665 20.4665 20.75 19.5 20.75H7.25C6.2835 20.75 5.5 19.9665 5.5 19V15C5.5 14.0335 6.2835 13.25 7.25 13.25H19.5ZM19.75 15C19.75 14.8619 19.6381 14.75 19.5 14.75H7.25C7.11193 14.75 7 14.8619 7 15V19C7 19.1381 7.11193 19.25 7.25 19.25H19.5C19.6381 19.25 19.75 19.1381 19.75 19V15Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconChartHorizontalBars as ReactComponent };
